"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BaseModel {
    constructor(source, transform) {
        source = source || {};
        if (transform === 'transformFromSalesforce') {
            this.transformFromSalesforce(source);
        }
        else if (transform === 'transformFromMappingJson') {
            this.transformFromMappingJson(source);
        }
        else {
            this.transformFromJson(source);
        }
    }
    transformToSalesforce() {
        const sfObject = {};
        Object.keys(this.salesforceFieldMap).forEach((key) => {
            sfObject[this.salesforceFieldMap[key]] = this[key];
        });
        return sfObject;
    }
    transformFromSalesforce(sfObject) {
        Object.keys(this.salesforceFieldMap).forEach((key) => {
            this[key] = sfObject[this.salesforceFieldMap[key]];
        });
        this._deleted = sfObject.IsDeleted;
    }
    transformFromMappingJson(json) {
        Object.assign(this, json);
    }
    transformFromJson(json) {
        Object.assign(this, json);
    }
}
exports.BaseModel = BaseModel;
//# sourceMappingURL=base.model.js.map